import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}
export const PasswordApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getPassword: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        length?: number;
        start?: number;
        status?:number
      }
    >({
      query: ({ length, search, start,status}) => ({
        url: `${END_POINTS.getPassword}?start=${start}&status=${status}&length=${length}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getPasswordById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getByIdPassword}${id}/`,
        method: "GET",
      }),
    }),
    updatePassword: builder.mutation<CommonResponseType, { body: any; id: number }>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updatePassword}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    deletePassword: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteOCR}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
useLazyGetPasswordQuery,
useLazyGetPasswordByIdQuery,
useUpdatePasswordMutation,
useDeletePasswordMutation
} = PasswordApi;
